import { createFileRoute } from "@tanstack/react-router"

import { MailVorlagenPage } from "@/components/admin/mail/mail-vorlagen-page"

export const Route = createFileRoute("/_app/admin/mail")({
  component: MailVorlagenPage,
})
